// Entry point for the build script in your package.json
// MS50 #2611: gate noisy [APP] diagnostic logging to development only.
// The <meta name="app-environment"> tag is rendered by the layout <head>.
const isDev = document.querySelector('meta[name="app-environment"]')?.content === "development";
if (isDev) console.log('[APP] JavaScript application.js loading...')

import "@hotwired/turbo-rails";
if (isDev) console.log('[APP] Turbo loaded')

import "./controllers";
if (isDev) console.log('[APP] Controllers loaded')

import * as bootstrap from "bootstrap";
import "./dark_mode_switcher.js";
window.bootstrap = bootstrap;
import "./live_search"

if (isDev) console.log('[APP] All modules loaded successfully')

// Initialize Bootstrap dropdowns on Turbo page loads
document.addEventListener("turbo:load", () => {
  // Initialize all dropdowns
  const dropdownElementList = document.querySelectorAll('[data-bs-toggle="dropdown"]');
  const dropdownList = [...dropdownElementList].map(dropdownToggleEl => new bootstrap.Dropdown(dropdownToggleEl));
});